<template>
   <div class="contact-container">
     <!-- Header -->
     <TopBar class="fixed-header"></TopBar>
 
     <!-- Main Content -->
     <div id="app" class="main-content">
       <router-view />
     </div>
 
     <!-- Footer -->
     <Footer class="fixed-footer"></Footer>
   </div>
 </template>
 
 <script>
 import TopBar from './components/Loyout/topBar.vue';
 import Footer from './components/Loyout/footer.vue';
 
 export default {
   name: 'App',
   components: { TopBar, Footer },
   data() {
     return {
       defaultActive: "/",
     };
   },
   created() {
     // 初始化语言设置
     if (this.$i18n.locale == "zh") {
       this.languageValue = '中文简体';
       this.languageOptions = [{ value: 'en', label: 'English' }];
     } else {
       this.languageValue = 'English';
       this.languageOptions = [{ value: 'zh', label: '中文简体' }];
     }
   },
   computed: {
     i18n() {
       return this.$i18n.locale;
     }
   },
 };
 </script>
 
 <style lang="scss" scoped>
 /* 确保 TopBar 固定在顶部 */
 .fixed-header {
   position: fixed;
   top: 0;
   left: 0;
   width: 100%;
   z-index: 1000; /* 确保在其他内容之上 */
   background-color: #fff; /* 根据需要调整背景颜色 */
   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* 添加阴影以增强视觉效果 */
 }
 
 /* 主内容区域，避免被固定的 TopBar 和 Footer 遮挡 */
 .main-content {
   padding-top: 150px; /* 根据 TopBar 的高度调整 */
   min-height: calc(100vh - 128px); /* 确保内容区域占满剩余空间 */
 }
 
 /* 确保 Footer 固定在底部 */
//  .fixed-footer {
//    position: fixed;
//    bottom: 0;
//    left: 0;
//    width: 100%;
//    z-index: 1000; /* 确保在其他内容之上 */
//    background-color: #f5f5f7; /* 根据需要调整背景颜色 */
//    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1); /* 添加阴影以增强视觉效果 */
//  }
 </style>